module.exports = __webpack_public_path__ + "static/img/003-5.17d600b4.png";